import React from 'react'
import ReactDOM from 'react-dom'
import Main from './Main'
import Web3 from 'web3'
import Promise from 'bluebird'
import './styles/index.css'

const web3 = new Web3(
  new Web3.providers.HttpProvider('https://mainnet.infura.io/')
)
web3.eth = Promise.promisifyAll(web3.eth)

ReactDOM.render(<Main web3={web3} />, document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js